export default __webpack_public_path__ + "4c99a2f764677e85b434c69dc27d239e.svg";